module.exports = __webpack_public_path__ + "static/TiemposText-RegularItalic-e87a11f5daa9e5cf244f594ec1fa21d5.woff";